import { ENTITY_NAME_LABELS, SCOPE_NAME_LABELS } from "../../interfaces/wallet/Wallet.types";
import { CATALOGUE_ENUM_LABELS } from "./enumValues";
import { PAYMENT_ENUM_LABELS, PURCHASE_TYPES } from "./enumValuesPayments";

// Columns that are enums on the backend, with the meaning of each value. Integer columns are keyed
// by the number stored; enum-typed columns arrive as the enum's name and are keyed by that name.
// This half covers reservations, wallets and money; enumValues.ts covers the timetable and catalogue,
// enumValuesPayments.ts payments, refunds to the card and disputes.
const FEE_ENUMS: Record<string, string> = {
  JourneyReservation: "Rezervimet e udhëtimeve",
  TravelBundle: "Paketat",
  Percentage: "Përqindje",
  FixedValue: "Vlerë fikse"
};
export const ENUM_VALUE_LABELS: Record<string, Record<string | number, string>> = {
  ...CATALOGUE_ENUM_LABELS,
  ...PAYMENT_ENUM_LABELS,
  "Ticket.StatusId": { 1: "Konfirmuar", 2: "Në pritje", 3: "Anuluar", 4: "Rimbursuar", 5: "Draft" },
  "OperatorInvoice.StatusId": { Generated: "Gjeneruar", Sent: "Dërguar", Cancelled: "Anuluar" },
  "OpenReturnEntitlement.Status": {
    Pending: "Në pritje",
    Selected: "Zgjedhur",
    Expired: "Skaduar",
    Canceled: "Anuluar"
  },
  "VoucherCode.RewardType": { Esim: "eSIM", Credits: "Gjirafa Money" },
  "VoucherCode.UsageMode": { Campaign: "Fushatë", EmailLocked: "I lidhur me një email" },
  "WalletTransaction.Type": {
    EsimPurchase: "Blerje eSIM",
    EsimTopUp: "Rimbushje eSIM",
    BusReservation: "Rezervim udhëtimi"
  },
  "WalletCredit.Type": {
    EarnedFromPurchase: "Fituar nga blerja",
    SpentOnPurchase: "Shpenzuar në blerje",
    Expired: "Skaduar",
    ManualAdjustment: "Rregullim manual",
    ReversedDueToCancellation: "Kthyer pas anulimit",
    EarnedFromReferral: "Fituar nga referimi",
    EarnedFromWelcome: "Fituar si mirëseardhje",
    EarnedFromExternalTransfer: "Fituar nga një transfertë e jashtme",
    EarnedFromVoucherRedemption: "Fituar nga një kupon",
    EarnedFromDailyChallenge: "Fituar nga sfida ditore",
    EarnedFromStreak: "Fituar nga seria e ditëve",
    EarnedFromSkyPilotTurbo: "Fituar nga loja SkyPilot",
    EarnedFromLeaderboard: "Fituar nga renditja",
    RefundedToCredits: "Rimbursim në Gjirafa Money",
    SpentCreditsReturned: "Kthim i Gjirafa Money të shpenzuar",
    AdminIssued: "Dhënë nga admini",
    AdminRevoked: "Hequr nga admini",
    SpentOnTravelReservation: "Shpenzuar në biletë udhëtimi",
    ServiceRecovery: "Kompensim për një përvojë të keqe"
  },
  "WalletCredit.Product": { Unspecified: "I papërcaktuar", Esim: "eSIM", Travel: "Bileta" },
  "WalletCredit.RedeemableScope": SCOPE_NAME_LABELS,
  // What a movement points at: a purchase, a game reward, or the lot an expiry row closes.
  "WalletCredit.EntityName": {
    ...ENTITY_NAME_LABELS,
    ...PURCHASE_TYPES,
    WalletCredit: "Lëvizje e mëparshme në Gjirafa Money"
  },
  "CreditReservationMapping.EntityName": PURCHASE_TYPES,
  "ApplicationForReservationAddition.ApplicationType": {
    Flex: "FlexiRide",
    Reschedule: "Ndryshim i datës",
    OpenReturnPriceDifference: "Diferencë çmimi për kthimin e hapur"
  },
  "PromotionCodeDiscountCalculation.PromotionCodeApplicationType": {
    AllTickets: "Të gjitha biletat",
    FixedNumberOfTickets: "Një numër i caktuar biletash"
  },
  "JourneyReservation.PaymentStatus": {
    1: "Konfirmuar",
    2: "Në pritje",
    3: "Anuluar",
    4: "Rimbursuar",
    5: "Draft"
  },
  "OperatorEntityCommisionFee.OperatorCommisionFeePaymentType": FEE_ENUMS,
  "OperatorEntityCommisionFee.OperatorCommisionFeeValueType": FEE_ENUMS,
  "OperatorCommisionFee.OperatorCommisionFeePaymentType": FEE_ENUMS,
  "OperatorCommisionFee.OperatorCommisionFeeValueType": FEE_ENUMS,
  "CustomTripWorkingDay.Type": { ExceptionDate: "Nuk qarkullon", SelectedWorkingDate: "Qarkullon" },
  "TripsNotices.TripNoticePriority": { High: "E lartë", Medium: "Mesatare", Low: "E ulët" },
  "TripsNotices.TripNoticeType": {
    ServiceDisruption: "Ndërprerje e shërbimit",
    RoadClosureOrDiversions: "Rrugë e mbyllur ose devijim",
    SpecialEventsOrPromotions: "Ngjarje ose promocion",
    SeatingInformation: "Informacion për uljet",
    LuggageRestrictions: "Kufizime për bagazhin",
    HealthAndSafetyGuidelines: "Udhëzime shëndeti dhe sigurie",
    PaymentOrTicketingNotices: "Njoftim për pagesën ose biletat",
    AmenitiesOnBoard: "Lehtësirat në bord",
    WeatherAlerts: "Paralajmërim për motin",
    EmergencyInformation: "Informacion emergjence",
    RulesAndRegulations: "Rregulla dhe kushte",
    BusUpgradesOrChanges: "Ndryshim i autobusit",
    Other: "Tjetër"
  },
  "LocalizedProperty.LanguageId": { 1: "Anglisht", 2: "Shqip" },
  "OperatorInvoiceAdjustment.Direction": { Removal: "Zbritje", Addition: "Shtesë" },
  "OperatorInvoiceAdjustment.Reason": {
    UserCancellation: "Anulim nga klienti",
    AdminReservationCancellation: "Anulim i rezervimit nga admini",
    AdminTicketCancellation: "Anulim i biletës nga admini",
    OperatorSwitchAway: "Kalim te operator tjetër",
    OperatorSwitchTo: "Kalim nga operator tjetër",
    InvoiceOnlyCancel: "Anulim vetëm në faturë",
    LostDisputeWithheld: "Pagesë e ndalur pas kontestimit të humbur"
  }
};
